import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "side-bar-body" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "side-bar-option-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-home" })
], -1)
const _hoisted_3 = { class: "side-bar-option-text" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "side-bar-option-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-check" })
], -1)
const _hoisted_5 = { class: "side-bar-option-text" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "side-bar-option-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chart-line" })
], -1)
const _hoisted_7 = { class: "side-bar-option-text" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "side-bar-option-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-credit-card" })
], -1)
const _hoisted_9 = { class: "side-bar-option-text" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "side-bar-option-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-contract" })
], -1)
const _hoisted_11 = { class: "side-bar-option-text contracts-section" }
const _hoisted_12 = { class: "contracts-text" }
const _hoisted_13 = ["title"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "notification-dot" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "side-bar-option-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-compass" })
], -1)
const _hoisted_16 = { class: "side-bar-option-text" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "side-bar-option-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-comment-dollar" })
], -1)
const _hoisted_18 = { class: "side-bar-option-text" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "side-bar-option-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" })
], -1)
const _hoisted_20 = { class: "side-bar-option-text" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "side-bar-option-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-hand-holding-dollar" })
], -1)
const _hoisted_22 = { class: "side-bar-option-text" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "side-bar-option-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-lines" })
], -1)
const _hoisted_24 = { class: "side-bar-option-text" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "side-bar-option-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info" })
], -1)
const _hoisted_26 = { class: "side-bar-option-text" }
const _hoisted_27 = {
  key: 9,
  class: "side-bar-group"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "side-bar-separator" }, null, -1)
const _hoisted_29 = { class: "side-bar-group-title sora-bold" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "side-bar-option-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-users-gear" })
], -1)
const _hoisted_31 = { class: "side-bar-option-text" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "side-bar-option-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-money-bill" })
], -1)
const _hoisted_33 = { class: "side-bar-option-text" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "side-bar-option-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-gear" })
], -1)
const _hoisted_35 = { class: "side-bar-option-text" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "side-bar-option-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-list-check" })
], -1)
const _hoisted_37 = { class: "side-bar-option-text" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "side-bar-option-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-rectangle-list" })
], -1)
const _hoisted_39 = { class: "side-bar-option-text" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "side-bar-option-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-check" })
], -1)
const _hoisted_41 = { class: "side-bar-option-text" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "side-bar-option-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-clipboard-list" })
], -1)
const _hoisted_43 = { class: "side-bar-option-text" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "side-bar-separator" }, null, -1)
const _hoisted_45 = { class: "side-bar-group log-out" }
const _hoisted_46 = ["title"]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "side-bar-option-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sign-out-alt" })
], -1)
const _hoisted_48 = { class: "side-bar-option-text sora-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["side-bar", { hidden: !_ctx.expanded }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        class: _normalizeClass(["side-bar-option", { selected: _ctx.page === 'home' }]),
        title: _ctx.$t('Home'),
        to: { name: 'home' }
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("Dashboard")), 1)
        ]),
        _: 1
      }, 8, ["class", "title"]),
      (_ctx.walletKind === 'unverified')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            class: _normalizeClass(["side-bar-option", { selected: _ctx.page === 'wallet-verification' }]),
            title: _ctx.$t('Wallet identity verification'),
            to: { name: 'wallet-verification' }
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("Identity verification")), 1)
            ]),
            _: 1
          }, 8, ["class", "title"]))
        : _createCommentVNode("", true),
      (_ctx.walletKind !== 'unverified')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            class: _normalizeClass(["side-bar-option", { selected: _ctx.page === 'activity' }]),
            title: _ctx.$t('Activity'),
            to: { name: 'activity' }
          }, {
            default: _withCtx(() => [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("Activity")), 1)
            ]),
            _: 1
          }, 8, ["class", "title"]))
        : _createCommentVNode("", true),
      (_ctx.walletKind !== 'unverified')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 2,
            class: _normalizeClass(["side-bar-option", { selected: _ctx.page === 'payment-methods' || _ctx.page === 'payment-method' }]),
            title: _ctx.$t('Payment methods'),
            to: { name: 'payment-methods' }
          }, {
            default: _withCtx(() => [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("Payment methods")), 1)
            ]),
            _: 1
          }, 8, ["class", "title"]))
        : _createCommentVNode("", true),
      (_ctx.walletKind !== 'unverified')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 3,
            id: "contracts-side-bar-button",
            class: _normalizeClass(["side-bar-option", { selected: _ctx.page === 'contracts' || _ctx.page === 'contract' }]),
            title: _ctx.$t('Contracts'),
            to: { name: 'contracts' }
          }, {
            default: _withCtx(() => [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("Contracts")), 1),
                (_ctx.pendingContracts > 0)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "contracts-notification-container",
                      title: _ctx.pendingContracts === 1 ? _ctx.$t('You have 1 contract waiting for signature') : _ctx.$t('You have $CONTRACTS contracts waiting for signature').replace('$CONTRACTS', _ctx.pendingContracts.toString())
                    }, [
                      _createElementVNode("span", null, "(" + _toDisplayString(_ctx.pendingContracts) + ")", 1),
                      _hoisted_14
                    ], 8, _hoisted_13))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["class", "title"]))
        : _createCommentVNode("", true),
      (_ctx.walletKind !== 'unverified')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 4,
            id: "loan-requests-side-bar-button",
            class: _normalizeClass(["side-bar-option", { selected: _ctx.page === 'loan-requests' || _ctx.page === 'loan-request' }]),
            title: _ctx.$t('Explore loan requests'),
            to: { name: 'loan-requests' }
          }, {
            default: _withCtx(() => [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("Explore loan requests")), 1)
            ]),
            _: 1
          }, 8, ["class", "title"]))
        : _createCommentVNode("", true),
      (_ctx.walletKind === 'borrower')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 5,
            id: "my-loan-requests-side-bar-button",
            class: _normalizeClass(["side-bar-option", { selected: _ctx.page === 'my-loan-requests' }]),
            title: _ctx.$t('My loan requests'),
            to: { name: 'my-loan-requests' }
          }, {
            default: _withCtx(() => [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("My loan requests")), 1)
            ]),
            _: 1
          }, 8, ["class", "title"]))
        : _createCommentVNode("", true),
      (_ctx.walletKind === 'borrower')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 6,
            class: _normalizeClass(["side-bar-option", { selected: _ctx.page === 'loan-new-request' || _ctx.page === 'personal-form' }]),
            title: _ctx.$t('New loan request'),
            to: { name: 'loan-new-request'}
          }, {
            default: _withCtx(() => [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("New loan request")), 1)
            ]),
            _: 1
          }, 8, ["class", "title"]))
        : _createCommentVNode("", true),
      (_ctx.walletKind === 'lender')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 7,
            class: _normalizeClass(["side-bar-option", { selected: _ctx.page === 'loan-offers' }]),
            title: _ctx.$t('My offers'),
            to: { name: 'loan-offers' }
          }, {
            default: _withCtx(() => [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t("My offers")), 1)
            ]),
            _: 1
          }, 8, ["class", "title"]))
        : _createCommentVNode("", true),
      (_ctx.walletKind === 'lender' || _ctx.walletKind === 'borrower')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 8,
            id: "my-disputes-side-bar-button",
            class: _normalizeClass(["side-bar-option", { selected: _ctx.page === 'disputes' }]),
            title: _ctx.$t('My disputes'),
            to: { name: 'disputes' }
          }, {
            default: _withCtx(() => [
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t("My disputes")), 1)
            ]),
            _: 1
          }, 8, ["class", "title"]))
        : _createCommentVNode("", true),
      _createVNode(_component_router_link, {
        id: "about-side-bar-button",
        class: _normalizeClass(["side-bar-option", { selected: _ctx.page === 'about' ||  _ctx.page === 'terms' || _ctx.page === 'cookies' || _ctx.page === 'privacy' || _ctx.page === 'help' }]),
        title: _ctx.$t('About'),
        to: { name: 'about' }
      }, {
        default: _withCtx(() => [
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t("About")), 1)
        ]),
        _: 1
      }, 8, ["class", "title"]),
      (_ctx.isAdmin || _ctx.hasIdentityVerificationPermission || _ctx.isSupervisor)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t("Administration options")), 1),
            (_ctx.isAdmin || _ctx.isSupervisor)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  class: _normalizeClass(["side-bar-option", { selected: _ctx.page === 'admin-users' || _ctx.page === 'admin-users-single' }]),
                  title: _ctx.$t('Users administration'),
                  to: { name: 'admin-users' }
                }, {
                  default: _withCtx(() => [
                    _hoisted_30,
                    _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t("Users administration")), 1)
                  ]),
                  _: 1
                }, 8, ["class", "title"]))
              : _createCommentVNode("", true),
            (_ctx.isAdmin || _ctx.isSupervisor)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  class: _normalizeClass(["side-bar-option", { selected: _ctx.page === 'admin-balance' }]),
                  title: _ctx.$t('Balance administration'),
                  to: { name: 'admin-balance' }
                }, {
                  default: _withCtx(() => [
                    _hoisted_32,
                    _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t("Balance administration")), 1)
                  ]),
                  _: 1
                }, 8, ["class", "title"]))
              : _createCommentVNode("", true),
            (_ctx.isAdmin)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 2,
                  class: _normalizeClass(["side-bar-option", { selected: _ctx.page === 'admin-payment-methods' }]),
                  title: _ctx.$t('Users administration'),
                  to: { name: 'admin-payment-methods' }
                }, {
                  default: _withCtx(() => [
                    _hoisted_34,
                    _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t("Payment methods configuration")), 1)
                  ]),
                  _: 1
                }, 8, ["class", "title"]))
              : _createCommentVNode("", true),
            (_ctx.hasIdentityVerificationPermission)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 3,
                  class: _normalizeClass(["side-bar-option", { selected: _ctx.page === 'admin-wallet-verification-requests' || _ctx.page === 'admin-wallet-verification-request' }]),
                  title: _ctx.$t('Identity verification requests'),
                  to: { name: 'admin-wallet-verification-requests' }
                }, {
                  default: _withCtx(() => [
                    _hoisted_36,
                    _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t("Identity verification requests")), 1)
                  ]),
                  _: 1
                }, 8, ["class", "title"]))
              : _createCommentVNode("", true),
            (_ctx.isAdmin)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 4,
                  class: _normalizeClass(["side-bar-option", { selected: _ctx.page === 'users-list' || _ctx.page === 'user-list-info' }]),
                  title: _ctx.$t('Check users list'),
                  to: { name: 'users-list' }
                }, {
                  default: _withCtx(() => [
                    _hoisted_38,
                    _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t("Check for possible forbidden users")), 1)
                  ]),
                  _: 1
                }, 8, ["class", "title"]))
              : _createCommentVNode("", true),
            (_ctx.isAdmin)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 5,
                  class: _normalizeClass(["side-bar-option", { selected: _ctx.page === 'admin-verified-wallets' || _ctx.page === 'admin-verified-wallet' }]),
                  title: _ctx.$t('Verified wallets'),
                  to: { name: 'admin-verified-wallets' }
                }, {
                  default: _withCtx(() => [
                    _hoisted_40,
                    _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t("Verified wallets")), 1)
                  ]),
                  _: 1
                }, 8, ["class", "title"]))
              : _createCommentVNode("", true),
            (_ctx.isAdmin)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 6,
                  class: _normalizeClass(["side-bar-option", { selected: _ctx.page === 'admin-resolve-disputes' || _ctx.page === 'admin-resolve-dispute' }]),
                  title: _ctx.$t('Resolve disputes'),
                  to: { name: 'admin-resolve-disputes' }
                }, {
                  default: _withCtx(() => [
                    _hoisted_42,
                    _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$t("Resolve disputes")), 1)
                  ]),
                  _: 1
                }, 8, ["class", "title"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _hoisted_44,
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("a", {
          id: "log-out-side-bar-button",
          class: "side-bar-option",
          title: _ctx.$t('Log out'),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
        }, [
          _hoisted_47,
          _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.$t("Log out")), 1)
        ], 8, _hoisted_46)
      ])
    ])
  ], 2))
}